import React from 'react';
import { Alert } from '@mui/material';
import { useEntity } from '@backstage/plugin-catalog-react';
import { EKSClusterResourceEntity } from '@eng-portal/czi-extensions-common';
import { ClusterCard } from '@eng-portal/plugin-argus';

export function ArgusClusterDetailsCard(): JSX.Element {
  const { entity: cluster } = useEntity<EKSClusterResourceEntity>();

  const { argusCluster } = cluster.spec;
  if (!argusCluster) {
    return <Alert severity="error">Argus cluster not found</Alert>;
  }

  return <ClusterCard titleOverride="Argus Cluster Details" cluster={argusCluster} />
}
